import React from "react"
import { Link } from "react-router-dom"
import type { DashboardActivity } from "../types"
import { formatRelativeTime } from "../utils/formatRelativeTime"
import "./DashboardActivityItem.style.scss"

interface DashboardActivityItemProps {
  activity: DashboardActivity
}

const DashboardActivityItem = ({ activity }: DashboardActivityItemProps) => {
  const Icon = activity.icon

  return (
    <Link
      to={activity.to}
      className={`dashboard-activity-item is-${activity.tone}`}
    >
      <div className="dashboard-activity-item__icon" aria-hidden>
        <Icon size={16} />
      </div>
      <div className="dashboard-activity-item__card">
        <div className="dashboard-activity-item__row">
          <h4>{activity.title}</h4>
          <time dateTime={activity.time}>
            {formatRelativeTime(activity.time)}
          </time>
        </div>
        <p>{activity.desc}</p>
      </div>
    </Link>
  )
}

export default DashboardActivityItem
